import { useMemo } from 'react'

import useSiteMetadata from '../../../hooks/useSiteMetadata'
import useSiteSettings from '../../../hooks/useSiteSettings'
import useUserCategory from '../../../hooks/useUserCategory'
import { langCodes } from '../../../utils/siteSettings'
import useShowDispensary from '../../practitioner-settings/hooks/useShowDispensary'
import {
  RewardsHistorySourceConfig,
  rewardsHistorySources as rewardsHistorySourcesImport,
  RewardsSourceConfig,
  rewardsSourceDispensary,
  rewardsSourceInPractice,
} from '../sources'

const useRewardsOrders = (): {
  sources: Array<RewardsSourceConfig>
  rewardsHistorySources: Array<RewardsHistorySourceConfig>
  showRewardsOrders: boolean
} => {
  const { lang } = useSiteSettings() || {}
  const { userCategory } = useUserCategory()
  const { featureFlags } = useSiteMetadata() ?? {}
  const shouldHideRewardsOrders = featureFlags?.hideRewardsOrders
  const [showDispensary] = useShowDispensary()

  const showRewardsOrders = useMemo(
    () =>
      (shouldHideRewardsOrders ? false : lang === langCodes.en_US || lang === langCodes.en_CA) &&
      userCategory === 'practitioner',
    [lang, shouldHideRewardsOrders, userCategory],
  )

  // for the US (legacy) and CA
  const sources = useMemo(() => {
    return showRewardsOrders
      ? [rewardsSourceInPractice, ...(showDispensary ? [rewardsSourceDispensary] : [])]
      : []
  }, [showRewardsOrders, showDispensary])

  // for the US only
  const rewardsHistorySources = useMemo(() => {
    return showRewardsOrders ? rewardsHistorySourcesImport : []
  }, [showRewardsOrders])

  return { sources, rewardsHistorySources, showRewardsOrders }
}

export default useRewardsOrders
